import { render, staticRenderFns } from "./PaymentPolicy.vue?vue&type=template&id=9acbc9d2&"
import script from "./PaymentPolicy.vue?vue&type=script&lang=js&"
export * from "./PaymentPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports